module.exports = "/static/assets/f8cdb37eb003162f43ef176f3206be7d.png";